import { get } from "lodash"
import * as ActionTypes from "services/state/action-types"

const SHARED_DATA_INITIAL_STATE = {
  loading: true,
  error: false,
  data: null,
  products: []
}

export function productsSharedData(state = SHARED_DATA_INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.GET_PRODUCTS_SHARED_DATA:
      return {
        ...state,
        loading: true,
        error: false
      }

    case ActionTypes.GET_PRODUCTS_SHARED_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        data: get(action, "payload.data", null),
        products: get(action, "payload.data.resultAssets", [])
      }

    case ActionTypes.GET_PRODUCTS_SHARED_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        data: null,
        products: []
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/services/state/sharedData/reducer.js